import React, { type ComponentProps } from 'react';

import { ProductCard as GarnishProductCard } from '@sg/garnish';

export const ProductCard = (props: ProductCardProps) => <GarnishProductCard {...props} />;

type ProductCardProps = ComponentProps<typeof GarnishProductCard>;
